const content = [
  {
    title: 'How long do trips last?',
    text: 'Trips last a total of three days, with two nights accommodation.',
  },
  {
    title: 'Can I bring a friend?',
    text:
      'Yes! With BRB we\'ve made it easy to bring a friend, simply choose "Add a friend" and pay a one-off fee.',
  },
  {
    title: 'Do I get to choose my destination?',
    text:
      'Destinations with BRB are selected for you by our team of travel experts. The destination is revealed a month before you travel, so you have plenty of time to prepare.',
  },
  {
    title: 'Can I cancel my subscription?',
    text:
      'Anytime. However the outstanding balance for any trips you’ve taken will need to be paid for. For example if you subscribed today, and took a trip in 3 months the outstanding month would need to be paid for.',
  },
  {
    title: 'Will I share with a stranger?',
    text:
      "Nope! Solo travel means solo, you'll have a room all to yourself, no hostels!",
  },
  {
    title: 'How do I choose my dates?',
    text:
      "Once you’ve subscribed you’ll be able to start organising your first trip. Pick a date, and a trip type, we'll handle the rest.",
  },
  {
    title: 'Are the trips ATOL protected?',
    text:
      'As a UK based travel company, all flight + hotel packages that we provide must be ATOL protected, so you’re covered.',
  },
  {
    title: 'Where will I travel from?',
    text:
      'Your trip will start at a London airport. Got a preference? Drop us a message and we can prioritise your favourite airport.',
  },
  {
    title: 'When are destinations revealed?',
    text: 'Destinations are revealed 1 month prior to your chosen weekend.',
  },
  {
    title: "Will you send me somewhere I've already been?",
    text:
      "You can exclude all the destinations you don't want to visit, or have travelled to before. So no, unless you want to go back somewhere 💁‍♀️.",
  },
];

export default content;
